import { Icon, Input } from '@ics-portal/guardian';
import { type ReactNode } from 'react';

interface HeaderProps {
    onSearchChange: (value: string) => void;
}

export function Header({ onSearchChange }: HeaderProps): ReactNode {
    return (
        <div className="flex flex-row justify-content-between align-items-center mt-2">
            <h4 className="m-0">Standard profiles:</h4>
            <Input
                name="search"
                placeholder="Search standards"
                onChange={(e) => {
                    onSearchChange(e.target.value);
                }}
                prefixIcon={<Icon name="search" />}
                className="gap-0"
                outlined
            />
        </div>
    );
}
